<div class="main-content">
    <div class="card">
        <p-toolbar styleClass="p-mb-4">
            <ng-template pTemplate="left"></ng-template>
            <ng-template pTemplate="right">
                <button pButton pRipple label="{{ 'PUB.ADD_NEW' | translate }}" icon="pi pi-plus"
                        class="p-button-success mr-2 njoyButton" (click)="addNew()"></button>
            </ng-template>
        </p-toolbar>
        <p-table #dt [value]="pubs" [rows]="10" [paginator]="true" [rowHover]="true"
                 [showCurrentPageReport]="true" [rowsPerPageOptions]="[10,25,50]">
            <ng-template pTemplate="header">
                <tr>
                    <th>{{ 'PUB.URL_LABEL' | translate }}</th>
                    <th>{{ 'PUB.IMAGE_LABEL' | translate }}</th>
                    <th></th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-pub>
                <tr (dblclick)="openUpdateModal(pub)">
                    <td>
                        {{pub?.pubURL}}
                    </td>
                    <td><img [src]="pub?.imagePath"
                             width="100" class="p-shadow-4"/>
                    <td>
                        <button pButton pRipple icon="pi pi-times" class="p-button-rounded njoyButton"
                                (click)="confirmDeletePub(pub)"></button>
                    </td>

                </tr>
            </ng-template>
        </p-table>
    </div>
</div>

<p-dialog *ngIf="addNewPubDialog" [(visible)]="addNewPubDialog" [style]="{width: '735px'}"
          [header]="modalTitle" [modal]="true"
          styleClass="p-fluid">
    <div class="container-fluid">
        <form [formGroup]="pubForm">
            <div class="row">
                <div class="col-md-2 mt-4">
                    <mat-label>{{ 'PUB.URL_LABEL' | translate }} *</mat-label>
                </div>
                <div class="col-md-10">
                    <mat-form-field class="example-full-width">
                        <input matInput formControlName="url"
                               [errorStateMatcher]="matcher" type="text">
                        <mat-error *ngIf="getControl?.url?.errors?.required">
                            {{ 'PUB.URL_REQUIRED_ERROR_LABEL' | translate }}
                            <strong>{{ 'COMMON.REQUIRED_FEMALE' | translate }}</strong>
                        </mat-error>
                    </mat-form-field>
                </div>
            </div>
            <div class="row mt-4">
                <div class="col-md-2 mt-5">
                    <mat-label>{{ 'CATEGORY.BACKGROUND_IMAGE' | translate }} *</mat-label>
                </div>
                <div class="col-md-10" *ngIf="!displayImage">
                    <p-fileUpload #fileUpload name="file" (onSelect)="onUpload($event)" (onClear)="clearFile()"
                                  (onRemove)="clearFile()"
                                  [showUploadButton]="false"
                                  accept="image/*">
                        <ng-template pTemplate="file">
                            <div class="p-fileupload-row">
                                <div>
                                    <span class="logo-tooltip">
                                        <img [src]="uploadedFile?.objectURL" class="middle-logo"/>
                                    </span>
                                </div>
                                <div>{{uploadedFile?.name}}</div>
                                <div>
                                    <button icon="pi pi-times" pButton type="button"
                                            (click)="clearFile()"></button>
                                </div>
                            </div>
                        </ng-template>
                    </p-fileUpload>
                    <mat-error style="font-size: 75%;" *ngIf="noFileUploaded">
                        {{ 'PARTNER.IMAGE_REQUIRED_LABEL' | translate }}
                        <strong>{{ 'COMMON.REQUIRED_FEMALE' | translate }}</strong>
                    </mat-error>
                </div>
                <div class="col-md-8" *ngIf="displayImage">
                                    <span class="logo-tooltip" (click)="changeImageValue()">
                                        <img [src]="selectedPub?.imagePath" class="middle-logo"/>
                                    </span>
                </div>
            </div>
        </form>
    </div>
    <ng-template pTemplate="footer">
        <button pButton pRipple label="{{ 'BUTTONS.SAVE' | translate }}" icon="pi pi-check" class="p-button-text"
                (click)="addOrUpdatePub()"></button>
    </ng-template>
</p-dialog>
<p-toast></p-toast>
<p-confirmDialog #cd header="Confirmation"
                 icon="pi pi-exclamation-triangle"
                 acceptLabel="{{ 'BUTTONS.YES' | translate }}"
                 rejectLabel="{{ 'BUTTONS.NO' | translate }}"
>
    <ng-template pTemplate="footer">
        <button type="button" pButton icon="pi pi-check" label="Yes" (click)="cd.accept()"></button>
        <button type="button" pButton icon="pi pi-times" label="No" (click)="cd.reject()"></button>
    </ng-template>
</p-confirmDialog>
